
(() => {
  const SELECTOR = ".announcement-bar__scroller";
  const INNER_SELECTOR = ".announcement-bar__scroller-inner";

  function initAnnouncementScroller(root = document) {
    const scrollers = root.querySelectorAll(SELECTOR);
    if (!scrollers.length) return;

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    scrollers.forEach((scroller) => {
      const scrollerInner = scroller.querySelector(INNER_SELECTOR);
      if (!scrollerInner) return;

      cleanupClones(scrollerInner);

      if (reduced) {
        scroller.removeAttribute("data-animated");
        scroller.dataset.animInit = "1";
        return;
      }

      scroller.setAttribute("data-animated", "true");
      duplicateOnce(scrollerInner);
      scroller.dataset.animInit = "1";
    });
  }

  function duplicateOnce(scrollerInner) {
    
    const originals = Array.from(scrollerInner.children).filter(
      (el) => !el.hasAttribute("data-marquee-clone")
    );

    originals.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", "true");
      duplicatedItem.setAttribute("data-marquee-clone", "true");
      scrollerInner.appendChild(duplicatedItem);
    });
  }

  function cleanupClones(scrollerInner) {
    scrollerInner
      .querySelectorAll("[data-marquee-clone]")
      .forEach((el) => el.remove());
  }


  document.addEventListener("DOMContentLoaded", () => {
    initAnnouncementScroller(document);
  });

  
  document.addEventListener("shopify:section:load", (e) => {
    initAnnouncementScroller(e.target);
  });

  document.addEventListener("shopify:section:select", (e) => {
    initAnnouncementScroller(e.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    initAnnouncementScroller(document);
  });

})();